import { SeverityLevel } from '@microsoft/applicationinsights-common'
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js'

const useLog = () => {
  const appInsights = useAppInsightsContext()

  const logAppInsightsInfo = (message: string) => {
    const infoObject = {
      message: message,
      severityLevel: SeverityLevel.Information,
    }

    if (import.meta.env.DEV) {
      console.log(infoObject)
      return
    }

    if (appInsights) {
      appInsights.trackTrace(infoObject)
    }
  }

  /** `properties` land in App Insights as customDimensions, so they can be queried. */
  const logAppInsightsWarning = (message: string, properties?: Record<string, unknown>) => {
    const warningObject = {
      message: message,
      severityLevel: SeverityLevel.Warning,
    }

    if (import.meta.env.DEV) {
      console.log(warningObject, properties)
      return
    }

    if (appInsights) {
      appInsights.trackTrace(warningObject, properties)
    }
  }

  const logAppInsightsError = (error: string) => {
    const errorObject = {
      message: error,
      severityLevel: SeverityLevel.Error,
    }

    if (import.meta.env.DEV) {
      console.log(errorObject)
      return
    }

    if (appInsights) {
      appInsights.trackException(errorObject)
    }
  }

  return { logAppInsightsInfo, logAppInsightsWarning, logAppInsightsError }
}

export { useLog }
